import MjmlTemplate from "../../models/mjmlTemplate"

const hasPath = (obj: any, path: string): boolean => {
  return path.split(".").every((key) => {
    if (obj && typeof obj === "object" && key in obj) {
      obj = obj[key]
      return true
    }
    return false
  })
}

export const isMjmlTemplateValid = (
  template: MjmlTemplate,
  formData: any
): boolean => {
  if (!template.validationRules || !template.validationRules.length) {
    return true
  }

  if (!formData) {
    return false
  }

  return template.validationRules.every((path) => hasPath(formData, path))
}
